module.exports = __webpack_public_path__ + "static/media/awards-3.6eeee378.png";